import styled from 'styled-components';
import { Link } from 'react-router-dom';

const BaseLink = styled(Link)`
  text-decoration: none;
  font-size: 3vw;
  position: relative;
  color: black;
  padding: 1.6vw 2.4vw;
  &:focus {
    outline: none;
  }
  &:hover {
    cursor: pointer;
  }
`;

export default BaseLink;
